<template>
  <div class="g-slider" id="product">
    <h2 class="g-slider__title">
      <img src="/ru/lg-signature/pushkinmuseum/images/desktop/slider/title.svg" alt="LG SIGNATURE">
    </h2>
    <div class="g-slider__swiper" v-swiper:mySwiper="swiperOption">
      <div class="swiper-wrapper">
        <div
            class="swiper-slide g-slider__swiper-slide"
            :key="index"
            v-for="(item, index) in content.slides"
        >
          <div class="g-slider__swiper-slide-content">
            <img class="g-slider__swiper-slide-image" :src="item.image_src" :alt="item.title">
            <h3 class="g-slider__swiper-slide-title" v-html="item.title" />
          </div>
        </div>
      </div>
      <div class="swiper-button-prev g-slider__pagination-prev">
        <svg width="104" height="76" viewBox="0 0 104 76" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M103.004 38L3.0039 38" stroke="#BA8748" stroke-width="3"/>
          <path d="M39 2.00024L3 38.0002L39 74.0002" stroke="#BA8748" stroke-width="3"/>
        </svg>
      </div>
      <div class="swiper-button-next g-slider__pagination-next">
        <svg width="103" height="76" viewBox="0 0 103 76" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.00390625 38L100.004 38" stroke="#BA8748" stroke-width="3"/>
          <path d="M64.0078 2.00024L100.008 38.0002L64.0078 74.0002" stroke="#BA8748" stroke-width="3"/>
        </svg>
      </div>
    </div>
    <transition name="fade" mode="out-in">
      <div class="g-slider__bottom-info" v-if="activeSlideData" :key="activeIndex">
        <ul class="g-slider__bottom-info-list">
          <li
            v-for="(item, index) in (activeSlideData.list || [])"
            :key="index"
          >
            <span>{{ item }}</span>
          </li>
        </ul>
        <div class="g-slider__bottom-info-btns">
          <a
            class="filled"
            :href="activeSlideData.buy_link || '#'"
          >
            <span>Где купить</span>
          </a>
          <a
            class="outlined"
            :href="activeSlideData.buy_online_link || '#'"
          >
            <span>Купить онлайн</span>
          </a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Slider",

  props: {
    content: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      activeIndex: 0,
      swiperOption: {
        slidesPerView: 1,
        autoHeight: true,
        centeredSlides: true,
        navigation: {
          nextEl: '.g-slider__pagination-next',
          prevEl: '.g-slider__pagination-prev',
        },
        breakpoints: {
          1601: {
            autoHeight: false,
            slidesPerView: 3
          }
        }
      }
    }
  },

  mounted () {
    this.mySwiper.on('slideChange', () => {
      this.activeIndex = this.mySwiper.activeIndex
    })

    this.mySwiper.slideNext()
  },

  computed: {
    activeSlideData () {
      return this.content?.slides?.[this.activeIndex] ?? {}
    }
  }
}
</script>

<style lang="scss">
@import 'slider';
</style>
